import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstname: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    lastname: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    email: {
      validations: [
        { type: 'required', message: 'Please provide an email.' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email' }
      ]
    },
    telnumber: {
      validations: [
        { type: 'required', message: 'Please provide a phone number.' },
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number' }
      ]
    },
    eventdate: {
      validations: [
        { type: 'dateinfuture', message: 'Event date must be in the future' }
      ]
    },
    theme: {
      validations: []
    },
    category: {
      validations: []
    },
    plannedguestcount: {
      validations: []
    },
    sitename: {
      validations: []
    },
    notes: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name:*',
            mapping: 'firstname'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name:*',
            mapping: 'lastname'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email:*',
            mapping: 'email'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone:*',
            mapping: 'telnumber'
          }
        ]
      },
      {
        fields: [
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'Event Date:',
            mapping: 'eventdate'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Event Type:',
            options: [
              { label: 'Breakfast'  , value: 'Breakfast'},
              { label: 'Box Lunch'  , value: 'Box Lunch'},
              { label: 'Lunch'  , value: 'Lunch'},
              { label: 'Dinner'  , value: 'Dinner'},
              { label: 'Reception'  , value: 'Reception'},
              { label: 'Drop-off/Delivery'  , value: 'Drop-off/Delivery'},
            ],
            mapping: 'theme'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Menu Selection:',
            options: [
              { label: 'Continental Breakfast '  , value: 'Continental Breakfast '},
              { label: 'Energy Breakfast '  , value: 'Energy Breakfast '},
              { label: 'Traditional Breakfast  '  , value: 'Traditional Breakfast  '},
              { label: 'Build Your Own Breakfast '  , value: 'Build Your Own Breakfast '},
              { label: 'Toast Bar '  , value: 'Toast Bar '},
              { label: 'Table d’hote'  , value: 'Table d’hote'},
              { label: 'Hand Crafted Egg Sandwiches'  , value: 'Hand Crafted Egg Sandwiches'},
              { label: 'Classic Deli Buffet '  , value: 'Classic Deli Buffet '},
              { label: 'Expressed Boxed Lunch'  , value: 'Expressed Boxed Lunch'},
              { label: 'Artisan Box Lunch'  , value: 'Artisan Box Lunch'},
              { label: 'Craft Salads '  , value: 'Craft Salads '},
              { label: 'Little Italy '  , value: 'Little Italy '},
              { label: 'Southern Delight '  , value: 'Southern Delight '},
              { label: 'The Grill '  , value: 'The Grill '},
              { label: 'Taste of Mediterranean '  , value: 'Taste of Mediterranean '},
              { label: 'Taco House '  , value: 'Taco House '},
              { label: 'Asia Fusion '  , value: 'Asia Fusion '},
              { label: 'Hors d’Oeuvres'  , value: 'Hors d’Oeuvres'},
              { label: 'Pasta Station '  , value: 'Pasta Station '},
              { label: 'Sweet Things '  , value: 'Sweet Things '},
              { label: 'Balanced Breaks'  , value: 'Balanced Breaks'},
              { label: 'Sweets & Treats'  , value: 'Sweets & Treats'},
              { label: 'Beverages'  , value: 'Beverages'},
              { label: 'Carved for you '  , value: 'Carved for you '},
              { label: 'Cordially Invited'  , value: 'Cordially Invited'},
            ],
            mapping: 'category'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Estimated Guest Count:',
            mapping: 'plannedguestcount'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Event Location:',
            options: [
              { label: 'McGrew A&B'  , value: 'McGrew A&B'},
              { label: 'Student Center Cyber Lounge'  , value: 'Student Center Cyber Lounge'},
              { label: 'Harvey Library'  , value: 'Harvey Library'},
              { label: 'Convocation Center'  , value: 'Convocation Center'},
              { label: 'Ballroom'  , value: 'Ballroom'},
              { label: 'Armstrong Slater'  , value: 'Armstrong Slater'},
              { label: 'Clark Hall'  , value: 'Clark Hall'},
              { label: 'The Museum'  , value: 'The Museum'},
            ],
            mapping: 'sitename'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'XLarge',
            label: 'Any Additional Details About Your Event?:',
            mapping: 'notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'SUBMIT'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Thompson Hospitality Contact Form',
    formId: '2113',
    clientKey: '0940FD24-82F3-4729-BD20-6FACC4BB187C',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    submissionText: 'Thank you! Your request has been received. Our catering coordinator will reach out to you within 24 business hours.',
    redirectUrl: '',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;
